import Vue from 'vue';
import router from '@/router/router';
import ScrollAnchor from '@/external/assorted/ScrollAnchor';

export const Editor = {
    state: {},
    mutations: {},
    getters: {
        editorMode(context, getters, rootState) {
            return ['editor', 'wizard'].indexOf(rootState.route.name) > -1;
        }
    },
    actions: {
        scrollInsideEditor(context, e) {
            let link = e.target.closest('a');
            if (link === null) {
                return;
            }
            let id = ScrollAnchor.extractIdFromLink(link.getAttribute('href')),
                source = context.getters.getCurrentRoutePath,
                target = ScrollAnchor.extractPageFromLink(link.getAttribute('href'));
            if (document.querySelector('[data-id="' + id + '"]') !== null) {
                ScrollAnchor.scrollTo(id);
            } else if (id === 'top' && source === '/editor' && target === '/') {
                ScrollAnchor.scrollTo(id);
            }
            // if on subpage, first go to target page
            else {
                router.push({ path: target }, () => {
                    Vue.nextTick(() => {
                        ScrollAnchor.scrollTo(id);
                    });
                });
            }
            // hide mobile menu
            if (document.querySelector('.mainmenu__state:checked') !== null) {
                document.querySelector('.mainmenu__state:checked').checked = false;
            }
        }
    }
};
